module.exports = __webpack_public_path__ + "img/banner_02.f52c5825.jpg";